<style src="./Modal.scss" lang="scss"></style>
<!-- <i18n src="./Modal.txt" lang="yaml"></i18n> -->
<script src="./Modal.js"></script>

<template>
    <div class="custom-modal">
        <div class="overlay"></div>
        <div class="modal fade show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="display: block">
            <div :class="size ? 'modal-dialog modal-'+size : 'modal-dialog'" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{title}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalCallback">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{message}}</p>
                        <slot></slot>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="primaryBtn.callback">{{primaryBtn?.text}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="secondaryBtn.callback">{{secondaryBtn?.text}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>